import React from 'react';

import Button from '@atlaskit/button/default/button';

const ButtonWarningExample = (): React.JSX.Element => {
	return <Button appearance="warning">Warning button</Button>;
};

export default ButtonWarningExample;
